import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV2'

/**
 * `AdapterDateFns` (V2 / date-fns 2.x) ships a `formatTokenMap` where `yy` and
 * `yyyy` are bare string entries (no `maxLength`). MUI X's `buildSectionsFromFormat`
 * relies on a runtime leading-zeros heuristic to derive the field's max length:
 * it formats year 1 and checks for a leading zero. With date-fns 2.x's `setYear`,
 * year 1 sometimes round-trips through the JS engine's two-digit-year rule and
 * comes back as 1901 — `'1901'.startsWith('0')` is false, so the heuristic falls
 * through to a branch that demands `maxLength` and throws:
 *
 *   "MUI X: The token yyyy should have a 'maxLength' property on it's adapter"
 *
 * It's racy because the outcome depends on the underlying Date arithmetic.
 * This subclass patches in explicit `maxLength: 4` for `yy` and `yyyy` so the
 * heuristic is bypassed entirely.
 */
export class PatchedAdapterDateFns extends AdapterDateFns {
  constructor(...args) {
    super(...args)
    this.formatTokenMap = {
      ...this.formatTokenMap,
      yy: { sectionType: 'year', contentType: 'digit', maxLength: 4 },
      yyyy: { sectionType: 'year', contentType: 'digit', maxLength: 4 },
    }
  }
}
